import StudyplanOrderInfo from './studyplan-order-info'

export default {
  StudyplanOrderInfo
}